import React, { Component, Fragment } from 'react'
import { Redirect } from 'react-router'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  project_profit_sheet_report_pdf as manual_pdf,
  project_profit_sheet_report_images as manual_images,
} from '../../../static/images/manual'

import bindActionCreators from '../../../lib/utils/bindActionCreators'

import LoadingBar from '../../../lib/components/LoadingBar'
import Manual from '../../../lib/components/Manual'

import { authAction, ppsAction } from '../../../actions'
import { authSelector, ppsSelector } from '../../../selectors'

import { fetchReport, resetModule } from './actions'
import { getFetching, getDate } from './selectors'

import LOBFilter from './components/LOBFilter'
import DateFilter from './components/DateFilter'
import ValueTab from './components/ValueTab'
import GPTab from './components/GPTab'
import MoreFilter from './components/MoreFilter'
import Table from './components/Table'
import Spreadsheets from './components/Spreadsheets'

import withAuth from './hocs/withAuth'

import Toolbar from './layout/Toolbar'
import Splitscreen from './layout/Splitscreen'

/**
 * @typedef {import('react-router-dom').RouteComponentProps} RouteComponentProps
 */

const { resetAuthUser } = authAction
const { redirectAuth } = authSelector

const { closeManual } = ppsAction
const { isManualOpen, isAuthorize } = ppsSelector

/**
 * @typedef {object} Props
 * @property {object} authUser
 * @property {boolean} fetching
 * @property {boolean} isManualOpen
 * @property {boolean} authorized
 * @property {{ from: import('moment').Moment, to: import('moment').Moment }} date
 * @property {typeof fetchReport} fetchReport
 * @property {typeof resetAuthUser} resetAuthUser
 * @property {typeof resetModule} resetModule
 * @property {typeof closeManual} closeManual
 */

/** @extends {Component<Props & RouteComponentProps>} */
class ProjectProfitSheetReport extends Component {
  componentDidMount = async () => {
    const { fetchReport, authUser, resetAuthUser, history, resetModule } = this.props
    const { redirect, isAuthenticated } = authUser

    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      await resetAuthUser()
      history.replace('/')
    } else {
      await resetModule()

      // javascript object reference issue
      await fetchReport(this.props.date.from, this.props.date.to)
    }
  }

  render = () => {
    const { fetching, isManualOpen, closeManual, authorized } = this.props

    if (!authorized) {
      return <Redirect to="/home" />
    }

    return (
      <Fragment>
        <LoadingBar isFetching={ fetching } />
        <Manual pdf={ manual_pdf } images={ manual_images } open={ isManualOpen } close={ closeManual } />
        <Toolbar.Root>
          <LOBFilter />
          <DateFilter />
          <GPTab />
          <ValueTab />
          <Toolbar.Spacer />
          <MoreFilter />
        </Toolbar.Root>
        <Splitscreen.Root>
          <Table />
          <Splitscreen.Scroller>
            <Spreadsheets />
          </Splitscreen.Scroller>
        </Splitscreen.Root>
      </Fragment>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  fetching: getFetching,
  date: getDate,
  authUser: redirectAuth,
  authorized: isAuthorize,
  isManualOpen,
})

const mapDispatchToProps = bindActionCreators({
  fetchReport,
  resetAuthUser,
  resetModule,
  closeManual,
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withAuth
)(ProjectProfitSheetReport)



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/page.js